import React, { useState } from 'react';
import { AlertTriangle, Move, RefreshCw, Save, X, Pencil } from 'lucide-react';
import { formatAddress } from '../../utils/clientMap';

const inputStyle = { width: '110px', padding: '8px 10px', border: '1px solid #E0E0E0', borderRadius: '8px', fontSize: '13px' };
const btn = (primary) => ({
  display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '8px 12px', borderRadius: '8px', fontSize: '13px', fontWeight: 500,
  cursor: 'pointer', border: primary ? 'none' : '1px solid #E0E0E0', backgroundColor: primary ? '#E53935' : '#FFF', color: primary ? '#FFF' : '#333',
});

function reasonLabel(c) {
  if (c.location && c.geocode.precision === 'city') return 'Nalezena jen obec – poloha je přibližná';
  if (c.geocode.status === 'pending' || !c.geocode.status) return 'Čeká na geokódování';
  if (c.geocode.status === 'error') return 'Chyba geokódovací služby';
  return 'Adresa nenalezena';
}

const UnresolvedPanel = ({ clients, editing, onStartEdit, onEditAddress, onEditChange, onCancel, onSave, onRetry, busy, error }) => {
  const [open, setOpen] = useState(true);
  if (clients.length === 0 && !editing) return null;

  return (
    <section aria-labelledby="unresolved-title" style={{ backgroundColor: '#FFF', borderRadius: '12px', border: '1px solid #FFE0B2', padding: '16px 20px', marginBottom: '16px' }}>
      <button type="button" onClick={() => setOpen(!open)} aria-expanded={open}
        style={{ display: 'flex', alignItems: 'center', gap: '8px', background: 'none', border: 'none', padding: 0, cursor: 'pointer', width: '100%', font: 'inherit' }}>
        <AlertTriangle size={18} color="#F57C00" />
        <h2 id="unresolved-title" style={{ fontSize: '15px', fontWeight: 600, color: '#333', margin: 0 }}>
          Nenalezené a nepřesné adresy ({clients.length})
        </h2>
        <span style={{ marginLeft: 'auto', fontSize: '12px', color: '#666' }}>{open ? 'Skrýt' : 'Zobrazit'}</span>
      </button>

      {open && (
        <ul style={{ listStyle: 'none', margin: '12px 0 0', padding: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {clients.map((c) => {
            const isEditing = editing?.key === c.key;
            return (
              <li key={c.key} style={{ border: '1px solid #F0F0F0', borderRadius: '8px', padding: '10px 12px', backgroundColor: isEditing ? '#FFF8E1' : '#FAFAFA' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px' }}>
                  <div style={{ flex: '1 1 220px', minWidth: 0 }}>
                    <div style={{ fontWeight: 600, fontSize: '14px', color: '#333' }}>{c.name}</div>
                    <div style={{ fontSize: '12px', color: '#666' }}>{formatAddress(c.address) || 'Bez adresy'} · {reasonLabel(c)}</div>
                  </div>
                  {!isEditing && (
                    <>
                      <button type="button" style={btn(true)} onClick={() => onEditAddress(c)}><Pencil size={14} /> Upravit adresu</button>
                      <button type="button" style={btn(false)} onClick={() => onStartEdit(c)}><Move size={14} /> Umístit ručně</button>
                      <button type="button" style={btn(false)} disabled={busy} onClick={() => onRetry(c)}><RefreshCw size={14} /> Zkusit znovu</button>
                    </>
                  )}
                </div>
                {isEditing && (
                  <div style={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap', alignItems: 'end', gap: '8px' }}>
                    <p style={{ flexBasis: '100%', margin: 0, fontSize: '12px', color: '#666' }}>
                      Přetáhněte bod na mapě nebo klikněte na správné místo, případně zadejte souřadnice.
                    </p>
                    <label style={{ fontSize: '12px', color: '#333' }}>Šířka (lat)<br />
                      <input style={inputStyle} inputMode="decimal" value={editing.latText} onChange={(e) => onEditChange('lat', e.target.value)} />
                    </label>
                    <label style={{ fontSize: '12px', color: '#333' }}>Délka (lng)<br />
                      <input style={inputStyle} inputMode="decimal" value={editing.lngText} onChange={(e) => onEditChange('lng', e.target.value)} />
                    </label>
                    <button type="button" style={btn(true)} disabled={busy || editing.lat == null} onClick={onSave}><Save size={14} /> Uložit polohu</button>
                    <button type="button" style={btn(false)} onClick={onCancel}><X size={14} /> Zrušit</button>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      )}
      {error && <p role="alert" style={{ margin: '10px 0 0', color: '#D32F2F', fontSize: '13px' }}>{error}</p>}
    </section>
  );
};

export default UnresolvedPanel;
